module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/menu_icon_files-958b0.png";